import React from 'react';

const redesignWelcomeDialogueOptions = (variant) => {
    return {
        theme: 'primary',
        title: variant === 'migrated' ? 'Welcome to the new design' : 'Thanks for trying the new design',
        icon: 'Gift',
        okLabel: 'Got it',
        okIcon: 'ThumbsUp',
        message: <RedesignWelcomeDialogueContent variant={variant} />,
    };
};

const RedesignWelcomeDialogueContent = ({ variant }) => {
    return <>
        <p>
            {variant === 'migrated'
                ? 'Welcome to the new app design. Here is what is better:'
                : 'Thanks for trying the new design. Here is what\' better:'}
        </p>

        <div className="pl-2 text-pretty">
            <Benefit emoji="🔍" title="Global search">
                Jump straight to customers, jobs, invoices, and more
            </Benefit>
            <Benefit emoji="🧭" title="Better navigation">
                So everyday tasks take fewer taps
            </Benefit>
            <Benefit emoji="✨" title="Many more improvements">
                We've made a ton of improvements across the app, with plenty still to come!
            </Benefit>
        </div>

        <p>
            We are still polishing things, so we would love your feedback - just drop Sid a message.
        </p>

        <p>
            You can switch back to the previous design in Settings → Experimental features if you need to.
        </p>
    </>;
};

const Benefit = ({ emoji, title, children }) => {
    return <div className="flex flex-row items-top mb-3">
        <span className="shrink-0 pr-3">{emoji}</span>
        <span className="grow">
            <strong>{title}</strong><br />
            {children}
        </span>
    </div>;
};

export { redesignWelcomeDialogueOptions };
